// extracted by mini-css-extract-plugin
export default {"element":"posts-nav_element__Beshv","buttons":"posts-nav_buttons__VK+P7","button":"posts-nav_button__Ee5OM","all":"posts-nav_all__kQcQW"};